module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_01_6DC79_1SD_GLU.707b94ca.png";